import device from "current-device";
import debounce from 'lodash-es/debounce';
import { store } from '../../store';
import * as _actions from './actions';
import * as _reducers from './reducers';
import * as _selectors from './selectors';
import * as _installedApp from './installed-app'
import * as _utils from './utils'

export const actions = _actions;
export const reducers = _reducers;
export const selectors = _selectors;
export const installedApp = _installedApp;
export const utils = _utils;

/**
 * Orientation changes listen.
 */
device.onChangeOrientation( debounce((orientation) => {
  store.dispatch(actions.orientationChanged(orientation));
}, 100));

/**
 * Viewport width changes listen.
 * Initialized after store is ready.
 */
let viewportWidthListenerInitialized = false;

const initViewportWidthTracking = () => {
  if (viewportWidthListenerInitialized) return;
  viewportWidthListenerInitialized = true;

  const updateViewportWidth = debounce(() => {
    store.dispatch(actions.updateViewportWidth(window.innerWidth));
  }, 100);

  window.addEventListener('resize', updateViewportWidth);

  // Dispatch initial viewport width
  store.dispatch(actions.updateViewportWidth(window.innerWidth));
};

// Initialize viewport width tracking when module is imported
// Use setTimeout to defer execution until after store is initialized
setTimeout(() => {
  initViewportWidthTracking();
}, 0);